import { LittleEmperorsIcon } from 'components/icons';
import { colorConstants } from 'data/constants';
import { Small } from 'components/text';
import { type FC } from 'react';
import { z } from 'zod';
import styles from './HotelBenefits.module.css';

const HotelBenefits: FC<HotelBenefitsProps> = ({
  benefits,
  benefits_footnotes,
}) => {
  return (
    <div className={styles.outerContainer}>
      <div className={styles.container}>
        <LittleEmperorsIcon color={colorConstants.black} />
        <div className={styles.title}>Little Emperors Benefits</div>
        <ul className={styles.benefit_list}>
          {benefits.map((benefit, index) => (
            <li className={styles.benefit} key={index}>
              {benefit}
            </li>
          ))}
        </ul>
      </div>
      {benefits_footnotes
        ? benefits_footnotes.map((footnote, index) => (
            <div className={styles.footnote} key={index}>
              <Small>{footnote}</Small>
            </div>
          ))
        : null}
    </div>
  );
};

export default HotelBenefits;

const HotelBenefitsSchema = z.object({
  benefits: z.array(z.string()),
  benefits_footnotes: z.array(z.string()).optional(),
});
type HotelBenefitsProps = z.infer<typeof HotelBenefitsSchema>;
